// import React from "react";
// import { Link } from "react-router-dom";
// import Stars from "./Stars";
// import { useTranslation } from "react-i18next";
// import { useCurrency } from "../../context/CurrencyContext";

// const ProductCard = ({ product, isAr, onToggleLike }) => {
//     const { t } = useTranslation();
//     const { formatPrice } = useCurrency();

//     if (!product) return null;

//     return (
//         <div
//             className="group transition-all duration-500 flex flex-col h-full relative overflow-hidden"
//             style={{
//                 backgroundColor: 'var(--bg-header)',
//                 borderRadius: 'var(--card-radius)',
//                 border: '1px solid var(--border)',
//                 boxShadow: 'var(--card-shadow)'
//             }}
//         >
//             {/* Like Button Wrapper */}
//             <button
//                 onClick={(e) => { e.preventDefault(); e.stopPropagation(); onToggleLike(product.id); }}
//                 className={`absolute top-4 ${isAr ? "left-4" : "right-4"} z-10 w-10 h-10 rounded-full backdrop-blur-md flex items-center justify-center transition-all duration-300 ${product.isLiked ? "bg-red-500 text-white shadow-lg shadow-red-200" : "bg-white/80 text-gray-400 hover:text-red-500 hover:bg-white shadow-sm hover:shadow-md"}`}
//             >
//                 <i className={`${product.isLiked ? "fas" : "far"} fa-heart text-lg`}></i>
//             </button>

//             {/* Image Container */}
//             <Link to={`/shop/${product.id}`} className="block relative overflow-hidden aspect-[4/5] bg-brand-bg-body/30">
//                 <img
//                     src={product.imageUrl || "/placeholder-furniture.jpg"}
//                     alt={product.name}
//                     className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//                 />
//                 {/* Hover Overlay */}
//                 <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//             </Link>

//             {/* Content */}
//             <div className="p-5 flex flex-col flex-1">
//                 {/* Category & Badge */}
//                 <div className="flex items-center justify-between mb-2">
//                     <span className="text-[10px] font-black uppercase tracking-widest text-brand-primary/60">
//                         {(product.categories || []).map(cat => (isAr && cat.name_ar ? cat.name_ar : cat.name)).slice(0, 1)}
//                     </span>
//                     {product.views > 100 && (
//                         <span className="bg-orange-50 text-orange-600 text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-tighter capitalize">
//                             {t('shop.sort_options.popular', 'Popular')}
//                         </span>
//                     )}
//                 </div>

//                 {/* Title */}
//                 <Link to={`/shop/${product.id}`} className="block">
//                     <h3 className="text-gray-900 font-extrabold text-lg mb-1 group-hover:text-brand-primary transition-colors line-clamp-1">
//                         {isAr && product.name_ar ? product.name_ar : product.name}
//                     </h3>
//                 </Link>

//                 {/* Dynamic Detail (Material/Color) */}
//                 <p className="text-gray-400 text-xs mb-3 font-medium flex items-center gap-1.5 capitalize">
//                     {isAr && product.material_ar ? product.material_ar : product.material}
//                     <span className="w-1 h-1 rounded-full bg-gray-200" />
//                     {isAr ? (product.color_ar || t(`colors.${product.color}`, product.color)) : product.color}
//                 </p>

//                 {/* Rating */}
//                 <div className="flex items-center gap-2 mb-4 bg-brand-primary/5 p-1.5 rounded-xl w-fit">
//                     <Stars value={product.avg_rating || 0} />
//                     <span className="text-[10px] font-bold text-gray-400">({product.reviews_count || 0})</span>
//                 </div>

//                 {/* Price & Action Row */}
//                 <div className="mt-auto pt-4 border-t flex items-center justify-between" style={{ borderColor: 'var(--border)' }}>
//                     <div className="flex flex-col">
//                         <span className="text-brand-primary text-xl font-black leading-tight">
//                             {formatPrice(product)}
//                         </span>
//                     </div>

//                     <Link
//                         to={`/shop/${product.id}`}
//                         className="w-10 h-10 bg-gray-900 text-white flex items-center justify-center group-hover:bg-brand-primary transition-all duration-300 transform group-hover:translate-x-1"
//                         style={{ borderRadius: 'var(--button-radius, 1rem)' }}
//                     >
//                         <i className={`fas fa-arrow-${isAr ? "left" : "right"} text-sm`}></i>
//                     </Link>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default React.memo(ProductCard);






import React from "react";
import { Link } from "react-router-dom";
import Stars from "./Stars";
import { useTranslation } from "react-i18next";
import { useCurrency } from "../../context/CurrencyContext";
import { useCart } from "../../context/CartContext";
import { useWishlist } from "../../context/WishlistContext";
import { useBranding } from "../../context/BrandingContext";
import { getUser } from "../../utils/auth";

const ProductCard = ({ product, isAr }) => {
    const { t } = useTranslation();
    const { formatPrice } = useCurrency();
    const { addToCart } = useCart();
    const { toggleWishlist, isInWishlist } = useWishlist();
    const { branding } = useBranding();

    if (!product) return null;

    const isCartEnabled = branding?.features?.cart !== false;
    const isWishlistEnabled = branding?.features?.wishlist !== false;
    const isComparisonEnabled = branding?.features?.comparison !== false;
    const isLiked = isInWishlist(product.id);
    const currentProfileId = branding?.profile_id || product.profile_id || 'default';

    const handleCompare = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const user = getUser();
        const userId = user?.id || 'guest';
        const storageKey = `compare_items_${currentProfileId}_${userId}`;
        const existing = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!existing.find(item => item.id === product.id)) {
            localStorage.setItem(storageKey, JSON.stringify([...existing, product]));
            window.dispatchEvent(new Event('compare_updated'));
            // Optional: Show toast or redirect
        }
    };

    return (
        <div className="group bg-white rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-500 flex flex-col h-full relative">
            {/* Top Actions Wrapper */}
            <div
                className={`absolute top-4 ${isAr ? "left-4" : "right-4"} z-40 flex flex-col gap-2`}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
            >
                {isWishlistEnabled && (
                    <button
                        type="button"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleWishlist(product); }}
                        className={`w-10 h-10 rounded-full backdrop-blur-md flex items-center justify-center transition-all duration-300 cursor-pointer ${isLiked ? "bg-red-500 text-white shadow-lg shadow-red-200" : "bg-white/80 text-gray-400 hover:text-red-500 hover:bg-white shadow-sm hover:shadow-md"}`}
                    >
                        <i className={`${isLiked ? "fas" : "far"} fa-heart text-lg`}></i>
                    </button>
                )}
                {isComparisonEnabled && (
                    <button
                        type="button"
                        onClick={handleCompare}
                        className="w-10 h-10 rounded-full bg-white/80 backdrop-blur-md text-gray-400 hover:text-brand-primary hover:bg-white flex items-center justify-center transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer"
                        title={t('shop.compare', 'Compare')}
                    >
                        <i className="fas fa-columns text-sm"></i>
                    </button>
                )}
            </div>

            {/* Image Container */}
            <div className="relative overflow-hidden aspect-[4/5] bg-gray-50">
                <Link to={`/shop/${product.id}`} className="block w-full h-full">
                    <img
                        src={product.imageUrl || "/placeholder-furniture.jpg"}
                        alt={product.name}
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    />
                    {/* Hover Overlay Gradient */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </Link>

                {/* Add to Cart Overlay */}
                {isCartEnabled && (
                    <div
                        className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-end justify-center p-4 translate-y-4 group-hover:translate-y-0 z-40"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
                    >
                        <button
                            type="button"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); addToCart(product); }}
                            className="w-full pointer-events-auto bg-white text-gray-900 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest shadow-2xl hover:bg-brand-primary hover:text-white transition-all transform active:scale-95 cursor-pointer"
                        >
                            <i className="fas fa-cart-plus mr-2"></i>
                            {t('shop.add_to_cart', 'Add to Cart')}
                        </button>
                    </div>
                )}
            </div>

            {/* Content */}
            <div className="p-5 flex flex-col flex-1">
                {/* Category & Badge */}
                <div className="flex items-center justify-between mb-2">
                    <span className="text-[10px] font-black uppercase tracking-widest text-brand-primary/60">
                        {(product.categories || []).map(cat => (isAr && cat.name_ar ? cat.name_ar : cat.name)).slice(0, 1)}
                    </span>
                    {product.views > 100 && (
                        <span className="bg-orange-50 text-orange-600 text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-tighter capitalize">
                            {t('shop.sort_options.popular', 'Popular')}
                        </span>
                    )}
                </div>

                {/* Title */}
                <Link to={`/shop/${product.id}`} className="block">
                    <h3 className="text-gray-900 font-extrabold text-lg mb-1 group-hover:text-brand-primary transition-colors line-clamp-1">
                        {isAr && product.name_ar ? product.name_ar : product.name}
                    </h3>
                </Link>
                <p className="text-gray-400 text-xs mb-3 font-medium flex items-center gap-1.5 capitalize">
                    {isAr && product.title ? product.title : product.title}
                </p>
                {/* Dynamic Detail (Material/Color) */}
                <p className="text-gray-400 text-xs mb-3 font-medium flex items-center gap-1.5 capitalize">
                    {isAr && product.material_ar ? product.material_ar : product.material}
                    <span className="w-1 h-1 rounded-full bg-gray-200" />
                    {isAr && product.color_ar ? product.color_ar : product.color}
                </p>

                {/* Rating */}
                <div className="flex items-center gap-2 mb-4 bg-gray-50/50 p-1.5 rounded-xl w-fit">
                    <Stars value={product.avg_rating || 0} />
                    <span className="text-[10px] font-bold text-gray-400">({product.reviews_count || 0})</span>
                </div>

                {/* Price & Action Row */}
                <div className="mt-auto pt-4 border-t border-gray-50 flex items-center justify-between">
                    <div className="flex flex-col">
                        <span className="text-brand-primary text-xl font-black leading-tight">
                            {formatPrice(product)}
                        </span>
                    </div>

                    <Link
                        to={`/shop/${product.id}`}
                        className="w-10 h-10 rounded-2xl bg-gray-900 text-white flex items-center justify-center group-hover:bg-brand-primary transition-all duration-300 transform group-hover:translate-x-1"
                    >
                        <i className={`fas fa-arrow-${isAr ? "left" : "right"} text-sm`}></i>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ProductCard);
